export const getAnalyze = state => state.analyze;

export const getPositive = state => state.positive;
export const getNegative = state => state.negative;
export const getAnalyzePresential = state => state.analyze_presential;

export const getHistory = state => [
  ...state.positive,
  ...state.negative,
  ...state.analyze_presential
];
